var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVineMobileLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 9,
  viewBox: "0 0 6 9",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3 0a3 3 0 0 1 3 3c0 1.657-2.593 5.1-3 5.1S0 4.657 0 3a3 3 0 0 1 3-3m0 2.05a.95.95 0 1 0 0 1.9.95.95 0 0 0 0-1.9"
})));
export default SvgVineMobileLocation;